import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { auth } from './firebase/init';
import './registerServiceWorker';
import './assets/tailwind.css'; // Import Tailwind CSS
import './assets/styles/variables.css';
import './assets/styles/theme.css'; // Make sure this is imported
import { createHead } from '@vueuse/head';

let app;
auth.onAuthStateChanged(() => {
  if (!app) {
    app = createApp(App).use(router).use(store).use(createHead()).mount('#app');
  }
});
